import { CalendarDays, Clock } from 'lucide-react'
import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { tv } from 'tailwind-variants'

interface DateTimePickerProps {
	label: string
	selectedDate: Date | null
	selectedTime: Date | null
	onDateTimeChange: (datetime: Date | null) => void
	invalid?: boolean
	disabled?: boolean
}

const dateTimePickerStyles = tv({
	base: 'w-full border rounded-md p-2 outline-none border-neutral-40',
	variants: {
		isDisabled: {
			true: 'cursor-not-allowed opacity-50 bg-neutral'
		},
		isInvalid: {
			true: 'border-red-50 text-red-50'
		}
	}
})

const iconStyles = tv({
	base: 'absolute top-1/2 -translate-y-1/2 right-3',
	variants: {
		isDisabled: {
			true: 'cursor-not-allowed opacity-50 bg-neutral'
		},
		isInvalid: {
			true: 'border-red-50 text-red-50'
		}
	}
})

const DateTimePicker: React.FC<DateTimePickerProps> = ({
	label,
	selectedDate,
	selectedTime,
	onDateTimeChange,
	disabled,
	invalid
}) => {
	return (
		<div className="flex flex-wrap md:flex-nowrap w-full gap-4">
			<div className="flex flex-col w-full">
				<label className="text-2xl font-semibold font-pp-neue-bit leading-5 text-neutral-50 mb-5">
					{label} DATE
				</label>
				<div className="w-full relative">
					<DatePicker
						selected={selectedDate}
						onChange={onDateTimeChange}
						dateFormat="dd/MM/yyyy"
						placeholderText="DD/MM/YYYY"
						className={dateTimePickerStyles({ isDisabled: disabled, isInvalid: invalid })}
						showPopperArrow={false}
						disabled={disabled}
					/>
					<CalendarDays className={iconStyles({ isDisabled: disabled, isInvalid: invalid })} />
				</div>
			</div>

			<div className="flex flex-col gap-5 w-full">
				<label className="text-2xl font-semibold font-pp-neue-bit leading-5 text-neutral-50">
					{label} TIME
				</label>
				<div className="w-full relative">
					<DatePicker
						disabled={disabled}
						selected={selectedTime}
						onChange={onDateTimeChange}
						showTimeSelect
						showTimeSelectOnly
						timeIntervals={5}
						timeCaption="Time"
						dateFormat="HH:mm"
						placeholderText="HH:MM"
						className={dateTimePickerStyles({ isDisabled: disabled, isInvalid: invalid })}
					/>
					<Clock className={iconStyles({ isDisabled: disabled, isInvalid: invalid })} />
				</div>
			</div>
		</div>
	)
}

export default DateTimePicker
